import { render, staticRenderFns } from "./supplementaryAgreement.vue?vue&type=template&id=a85cb58c&"
import script from "./supplementaryAgreement.vue?vue&type=script&lang=js&"
export * from "./supplementaryAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports